import { IFeature } from 'mod/featureV2/interface';

const image = {
    src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
    // href: '/vivosun-smart-grow-box?mock=1',
    subtitle: 'Smart Grow Box',
    title: 'productBanner image',
    description: 'High-quality growing in a compact design. Ideal for any space.',
}

const video = {
    bgcolor: '#141414',
    src: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
    poster: 'asset/width-3840/picture/6407c9150a111a6a0c7080a257d497ff.jpg',
    subtitle: 'Smart Grow Box',
    title: 'productBanner Video',
    description: 'Video banners with overlay cannot control playback.',
}

export const productBanner: IFeature = {
    moduleId: 'productBanner',
    type: 'productBanner',
    config: {
        width: 1500,
        height: 2668,
        threshold: [0.1, 0.2, 1],
        playThreshold: 0.2,
        banner: image,
        overlay: {
            align: 'center',
            positonX: 'center',
            positonY: 'top',
        },
        // //https://tool.chinaz.com/tools/unixtime.aspx
        // // endTime: 1703865599, // day
        // // endTime: 1703779199, // hour
        countdown: {
            endTime: 1735617599,
        },
        linkButton: {
            href: '/vivosun-smart-grow-box?mock=1',
            buttonText: 'Go Product',
        },
        previewerButton: {
            buttonText: 'Watch Video <em class="iconfont icon-play"></em>',
            width: 1200,
            height: 675,
            maskOpacity: 30,
            video: {
                src: 'file-asset/file/8deaba7eb62a69ec8bf35e78b4bb89b4/1700624582353/a.m3u8',
                poster: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
                autoPlay: false,
                muted: false,
            }
        },
    }
};

export const productBanner2: IFeature = {
    ...productBanner,
    moduleId: 'productBanner2',
    config: {
        ...productBanner.config,
        banner: video,
        overlay: {
            align: 'center',
            positonX: 'center',
            positonY: 'bottom',
            style: {
                color: '#4288b2'
            }
        },
        // //https://tool.chinaz.com/tools/unixtime.aspx
        // // endTime: 1703865599, // day
        // // endTime: 1703779199, // hour
        countdown: {
            endTime: 1735617599,
            bgColor: '#4288b2',
            color: '#fff',
        },
        price: {
            // showMarketPrice: true,
            shopPriceColor: '#4288b2',
            marketPriceColor: '#4288b2',
        },
        productOptions: {
            disableActions: ['addToCart'],
            buyNowBtnText: 'BUY NOW',
            buyNowBtnProps: { type: 'primary' },
            addToCartBtnText: 'ADD TO CART',
            addToCartBtnProps: { type: 'b' },
        },
        linkButton: {
            href: '/vivosun-smart-grow-box?mock=1',
            buttonText: 'Go Product &gt;',
            buttonProps: {
                type: 'primary'
            }
        },
        previewerButton: {
            buttonText: 'VIEW IMAGE &gt;',
            buttonProps: {
                type: 'base',
                style: {
                    background: '#4288b2',
                    border: 'none',
                    color: '#fff',
                }
            },
            width: 1480,
            height: 200,
            maskOpacity: 80,
            image: {
                src: 'asset/width-2960/picture/956410e1bcafaaa72205070d310c7861.jpg',
                href: '/'
            }
        },
    }
};